import { render, staticRenderFns } from "./BoxedLogin.vue?vue&type=template&id=e2865384"
import script from "./BoxedLogin.vue?vue&type=script&lang=js"
export * from "./BoxedLogin.vue?vue&type=script&lang=js"
import style0 from "./BoxedLogin.vue?vue&type=style&index=0&id=e2865384&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports